/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import SpinnerButton from "./SpinnerButton";
import { status as bidStatus } from "../../../helpers/types";
import {
  acceptPendingBid,
  resetBannerActionState,
  fetchBidSummary,
  fetchBidMessages
} from "../../../slices/bidSummarySlice";
import { fetchBidDetails } from "../../../slices/bidDetailsSlice";
import ErrorMessage from "./ErrorMessage";
import RejectBidModal from "../../RejectBidModal";
import messages from "../../../helpers/messages";

function PricingViewPendingBidState({ role, summary, mode }) {
  const [rejectBidModal, toggleRejectBidModal] = useState(false);
  const dispatch = useDispatch();
  const { acceptActionIsLoading, acceptActionFailure } = useSelector(
    state => state.bidSummary
  );
  const route = useLocation().pathname.split("/")[3] || "";

  const { modes, bidId } = summary;
  const { bidModeId } = modes.find(
    x => x.mode === mode && x.status === bidStatus.pending
  );

  const handleAcceptClick = useCallback(
    (bidModeId, bidId) => {
      dispatch(resetBannerActionState());
      dispatch(acceptPendingBid(bidModeId, bidId, role, route));
    },
    [dispatch, role, route]
  );

  const handleRejectModalClose = success => {
    toggleRejectBidModal(false);
    if (success) {
      dispatch(fetchBidSummary({ bidId, role }));
      route === "summary" && dispatch(fetchBidMessages(bidId));
      route === "details" && dispatch(fetchBidDetails(bidId));
    }
  };
  const openRejectModal = () => {
    toggleRejectBidModal(true);
    dispatch(resetBannerActionState());
  };

  return (
    <>
      <RejectBidModal
        open={rejectBidModal}
        bidId={bidId}
        bidModeId={bidModeId}
        handleClose={handleRejectModalClose}
      />
      <p className="inline-block font-size-14 pt-16 mb-0">
        {acceptActionFailure ? (
          <ErrorMessage />
        ) : (
          messages.thisBidHasNotYetBeenAcceptedForPricing.defaultMessage
        )}
      </p>
      <div className="fr py-8 my-2">
        {acceptActionIsLoading ? (
          <SpinnerButton minWidth="78px" />
        ) : (
          <button
            className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32"
            data-testid="accept"
            onClick={() => handleAcceptClick(bidModeId, bidId)}
            style={{ minWidth: "78px" }}
          >
            {messages.accept.defaultMessage}
          </button>
        )}
        <button
          className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32"
          data-testid="reject"
          onClick={openRejectModal}
          style={{ minWidth: "76px" }}
        >
          {messages.reject.defaultMessage}
        </button>
      </div>
    </>
  );
}

export default PricingViewPendingBidState;
